'use strict';

angular.module('contartemx.cuenta.administrar.baja', [
	'contartemx',
	'ui.router',
	'ui.bootstrap'
])

.controller('BajaCuentaCtrl', function BajaCuentaController($scope, $state, callToWebService) {

});
